module.exports = __webpack_public_path__ + "static/media/visible.048f0f99.png";